/** Google Analytics 4 (gtag.js) for deskreplay.com marketing site only. */

let activeMeasurementId: string | null = null;
let loadPromise: Promise<void> | null = null;

function ensureGtagStub(): void {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // Must match Google's snippet: push `arguments`, not a rest-parameter array.
    window.gtag = function gtag() {
      window.dataLayer!.push(arguments);
    };
    window.gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
}

function injectGtagScript(measurementId: string): Promise<void> {
  const src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Google Analytics"));
    document.head.appendChild(script);
  });
}

export function loadGoogleAnalytics(measurementId: string): Promise<void> {
  if (!measurementId) return Promise.resolve();
  if (activeMeasurementId === measurementId && loadPromise) {
    setAnalyticsConsentGranted(true);
    return loadPromise;
  }

  ensureGtagStub();
  window.gtag!("js", new Date());

  loadPromise = injectGtagScript(measurementId)
    .then(() => {
      activeMeasurementId = measurementId;
      setAnalyticsConsentGranted(true);
      window.gtag!("config", measurementId);
    })
    .catch((err) => {
      loadPromise = null;
      activeMeasurementId = null;
      throw err;
    });

  return loadPromise;
}

export function setAnalyticsConsentGranted(granted: boolean): void {
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
  });
}

export function trackPageView(pagePath: string): void {
  if (!activeMeasurementId || !window.gtag) return;
  window.gtag("config", activeMeasurementId, {
    page_path: pagePath,
    page_location: window.location.href,
  });
}
